<template>
  <div class="main-layout main-layout_fullpage">
    <div class="main-layout__controls">
      <Select2
        :settings="{ placeholder: $t('navigation.clients'), allowClear: false }"
        :options="modifiedClients"
        v-model="client_id"
        class="mr-12"
      />
    </div>

    <div class="main-layout__head main-layout__head_pb24">
      <h2 class="main-title">Todo</h2>
    </div>

    <todo-list :clientId="client_id" />
  </div>
</template>

<script>
import todoList from '@/components/lists/todo/todoList'

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'todo-page',
    components: {
        todoList,
    },
    data() {
        return {
            client_id: null,
            modifiedClients: [{ text: this.$t('listsHeader.all'), id: 'all' }],
        }
    },
    computed: {
        ...mapGetters({
            clients: 'clientsData',
        }),
    },
    watch: {
        client_id() {
            this.fetch({ client_id: this.client_id === 'all' ? '' : this.client_id })
        },
    },
    methods: {
        ...mapActions({
            fetch: 'todo/fetch',
            getClientsData: 'getClientsData',
        }),
        onSelectClient() {},
        prepareClients() {
            if (this.clients.length === 0 || this.modifiedClients.length > 1) return

            this.clients.forEach((client) => {
                this.modifiedClients.push({
                    id: client.id,
                    text: `${client.first_name} ${client.last_name}`,
                })
            })
        },
        prepareClientId() {
            const { id } = this.$route.query

            this.client_id = id

            if (!id) {
                this.fetch({ client_id: this.client_id })
            }
        },
    },
    async mounted() {
        await this.getClientsData({})
        this.prepareClients()
        this.prepareClientId()
    },
}
</script>
